import "../Checkbox.css";
import { jsx } from "react/jsx-runtime";
import { Checkbox as Checkbox$1 } from "antd";
import { useTheme } from "./Theme/UI.js";
import "./Theme/themeUtils.js";
import "./Theme/themes.js";
const base = "Checkbox_base_61389";
const css = {
  base
};
const Checkbox = (props) => {
  const {
    themeSettings: { className: themeClass }
  } = useTheme();
  const classes = [css.base, themeClass];
  return /* @__PURE__ */ jsx(Checkbox$1, { className: classes.join(" "), ...props });
};
Checkbox.Group = Checkbox$1.Group;
export {
  Checkbox as default
};
